export default class InventoryReasonsRepository {
  getAll() {
    throw new Error('Method not implemented')
  }
}
